module.exports = __webpack_public_path__ + "img/fix_blurry_images2.2afccbbf.jpg";